import h from 'react-hyperscript';
import { Route, Switch } from 'react-router-dom';

import { App, TermsOfService, PrivacyPolicy, SecurityPolicy, NotFound } from '../../components';
import { Default as DefaultLayout } from '../../layouts';

const AppContainer = () =>
  h('main', [
    h(Switch, {}, [
      h(Route, { path: '/terms-of-service', exact: true }, [h(TermsOfService)]),
      h(Route, { path: '/privacy', exact: true }, [h(PrivacyPolicy)]),
      h(Route, { path: '/security', exact: true }, [h(SecurityPolicy)]),
      h(Route, { path: '/', exact: true }, [h(DefaultLayout, { component: App })]),
      h(Route, { path: '/*', component: NotFound }),
    ]),
  ]);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/AppContainer/AppContainer.js